var UitkScrollableTags = [
    'div',
    'article',
    'aside',
    'footer',
    'header',
    'section',
    'ul',
    'ol',
    'li',
    'main'
];

export { UitkScrollableTags };
